/* unplugin-vue-components disabled */import script from "./integralSignMask.vue?vue&type=script&setup=true&lang=js"
export * from "./integralSignMask.vue?vue&type=script&setup=true&lang=js"

import "./integralSignMask.vue?vue&type=style&index=0&id=71b3dc31&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b3dc31"]])

export default __exports__